import moment from 'moment-timezone';

/**
 * Determine whether financial-year mode is enabled from the aw config object.
 * Driven by the `fees_calculator_financial_year` flag, accepted either at the
 * top level of the config or nested under journey_config(.ceremonies).
 * Accepts boolean true or the string 'true'.
 */
export function isFinancialYearEnabled(config: any): boolean {
  const cfg: any = config || {};
  const flag =
    cfg.fees_calculator_financial_year ??
    cfg?.journey_config?.ceremonies?.fees_calculator_financial_year ??
    cfg?.journey_config?.fees_calculator_financial_year;
  return flag === true || flag === 'true';
}

/**
 * Compute the fee-year key for a booking date.
 *   financialYear = true  -> financial year (Apr 1 -> Mar 31), key format YY/YY (e.g. 26/27)
 *   financialYear = false -> calendar year (Jan 1 -> Dec 31), key format YYYY (e.g. 2026)
 */
export function getFeeYearKey(date: any, financialYear: boolean): string {
  const m = moment(date);
  if (!financialYear) {
    return `${m.year()}`;
  }
  // Financial year runs April 1 -> March 31; moment months are 0-indexed (Apr = 3).
  const startYear = m.month() >= 3 ? m.year() : m.year() - 1;
  const yy = (y: number) => `${y % 100}`.padStart(2, '0');
  return `${yy(startYear)}/${yy(startYear + 1)}`;
}

/**
 * Resolve the fund code for an extra-item data block. When the item carries an
 * enhancedFundCode map and the booking's year key is present in it, use the
 * year-matched code; otherwise fall back to the top-level fundCode.
 */
export function resolveFundCode(itemData: any, date: any, financialYear: boolean): string | undefined {
  if (!itemData) {
    return undefined;
  }
  const enhanced = itemData.enhancedFundCode;
  if (enhanced && typeof enhanced === 'object') {
    const key = getFeeYearKey(date, financialYear);
    if (Object.prototype.hasOwnProperty.call(enhanced, key)) {
      return enhanced[key];
    }
  }
  return itemData.fundCode;
}
